import { ILoadPanelProps } from 'devextreme-react/data-grid';
import indicatorSrc from '../../common/assets/loadingIndicator.svg';

const loadPanel: ILoadPanelProps = {
	indicatorSrc,
	showIndicator: true,
	shading: true,
	showPane: false,
	shadingColor: 'rgba(255,255,255,0.8)',
	text: ''
};

export { loadPanel };
